import Vista from "../../components/Vista";
import { ChecklistStyles } from "../../utils/styles";
import Selector from "./Selector";
import { useEffect, useRef, useState } from "react";
import DatosGenerales from "./DatosGenerales";
import Check from "./Check";
import Gasolina from "./Gasolina";
import Firma from "./Firma";
import { useAlert } from "../../hooks/useAlert";
import Servo from "../../services/servo";
import { useMessages } from "../../hooks/useMessages";
import { useHistory } from "react-router-dom";
import moment from "moment";
import FirebaseStorage from "../../services/firebase";
import {NavLink} from "react-router-dom";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { CircularProgress, Grid } from "@mui/material";
import ChecklistArchivos from "./ChecklistArchivos";
import pickupPlanos from "../../assets/img/pickupPlanos.png";
import sedanPlanos from "../../assets/img/sedanPlanos.png";
import gruaPlanos from "../../assets/img/gruaPlanos.png";
import toneladaPlanos from "../../assets/img/toneladaPlanos.png";

let vs = ChecklistStyles();
const Detail = ({ match }) => {

  const [screen, setScreen] = useState("DatosGenerales");
  const { showAlert } = useAlert();
  const id = match?.params?.id;
  const editado = !!id;
  const { setMessages } = useMessages();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [uploadedPhotos, setUploadedPhotos] = useState([]);
  const permisoCheck = "checklistsEmpleados";
  const [permiso] = useLocalStorage("permiso", {});

  const getDatos = async () => {
    setLoading(true);
    let res = await Servo.get(
      "checklists-empleados" +
      "?idChecklistEmpleado=" +
      id +
      "&expand=datoschecklistsEmpleados.areas,datoschecklistsEmpleados.carros,datoschecklistsEmpleados.empresas,detallechecklistsEmpleados,gasolinachecklistsEmpleados.notas,checklistsarchivosEmpleados.archivos,firmachecklistsEmpleados.archivos"
    );
    if (res?.cuerpo?.resultado && res?.cuerpo?.resultado?.length > 0) {
      setCarro(res?.cuerpo?.resultado[0]?.datoschecklistsEmpleados?.carros);
      setArea(res?.cuerpo?.resultado[0]?.datoschecklistsEmpleados?.areas);
      setEmpresa(res?.cuerpo?.resultado[0]?.datoschecklistsEmpleados?.empresas);
      setformDetails(res?.cuerpo?.resultado[0]?.datoschecklistsEmpleados);
      setLucesDelanteras(
        JSON.parse(
          res?.cuerpo?.resultado[0]?.detallechecklistsEmpleados?.lucesDelanteras
        )
      );
      setLucesTraseras(
        JSON.parse(res?.cuerpo?.resultado[0]?.detallechecklistsEmpleados?.lucesTraseras)
      );
      setLiquidoVehiculo(
        JSON.parse(
          res?.cuerpo?.resultado[0]?.detallechecklistsEmpleados?.liquidoVehiculo
        )
      );
      setCarroceria(
        JSON.parse(res?.cuerpo?.resultado[0]?.detallechecklistsEmpleados?.carroceria)
      );
      setEquipoSeguridad(
        JSON.parse(
          res?.cuerpo?.resultado[0]?.detallechecklistsEmpleados?.equipoSeguridad
        )
      );
      setFrenos(
        JSON.parse(res?.cuerpo?.resultado[0]?.detallechecklistsEmpleados?.frenos)
      );
      setLlantas(
        JSON.parse(res?.cuerpo?.resultado[0]?.detallechecklistsEmpleados?.llantas)
      );
      setBateria(
        JSON.parse(res?.cuerpo?.resultado[0]?.detallechecklistsEmpleados?.baterias)
      );
      setGasolinaInfo(res?.cuerpo?.resultado[0]?.gasolinachecklistsEmpleados);
      setPoints(res?.cuerpo?.resultado[0]?.gasolinachecklistsEmpleados?.notas);
      setDataGas(res?.cuerpo?.resultado[0]?.gasolinachecklistsEmpleados?.gasolina);
      let archivosParaCheckEmpleados = [];
      res?.cuerpo?.resultado[0]?.checklistsEmpleadoArchivo.forEach((check) => {
        archivosParaCheckEmpleados.push(check.archivos);
      });
      setChecklistsEmpleadoArchivos(archivosParaCheckEmpleados);
    }

    setLoading(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      if (editado) {
        await getDatos();
      }
    };

    fetchData();
  }, [editado]);

  const validacionesToChange = () => {
    let dg = true;

    if (!carro?.idCarro) {
      if (screen == "DatosGenerales") {
        showAlert({
          message: "seleccionar un carro, es requerido",
          severity: "warning",
        });
      }
      dg = false;
    }
    if (!empresa?.idEmpresa) {
      if (screen == "DatosGenerales") {
        showAlert({
          message: "seleccionar una empresa, es requerido",
          severity: "warning",
        });
      }
      dg = false;
    }
    if (!area?.idArea) {
      if (screen == "DatosGenerales") {
        showAlert({
          message: "seleccionar un Área, es requerido",
          severity: "warning",
        });
      }
      dg = false;
    }

    let gas = true;

    if (gasolinaInfo?.gasolina == "") {
      if (screen == "Gasolina") {
        showAlert({
          message: "el campo gasolina, es requerido",
          severity: "warning",
        });
      }
      gas = false;
    }
    if (gasolinaInfo?.kilometraje == "") {
      if (screen == "Gasolina") {
        showAlert({
          message: "el campo kilometraje, es requerido",
          severity: "warning",
        });
      }
      gas = false;
    }

    let evidencia = true;

    // Verifica si se han subido al menos 4 fotos
    if (checklistsEmpleadoArchivos?.length < 4) {
      if (screen == "checklistsEmpleadoArchivos") {
        showAlert({
          message: "Subir al menos 4 fotos",
          severity: "warning",
        });
      }
      evidencia = false;
    }

    return { dg, gas, evidencia };
  };

  const formDefault = {
    seguro: false,
    tarjetaCirculacion: false,
    licencia: false,
    ubicacion: "",
    tipoChecklist: "",
  };

  const uploadFile = async (fileToUpload) => {
    if (archivo) {
      await FirebaseStorage.delete(folder, archivo?.nombreFirebase);
    }
    const blob = await new Promise((resolve) => fileToUpload.toBlob(resolve));
    const folder = "Archivos";
    const ranm = Math.floor(Math.random() * 1000);
    const nombreFirebase =
      "Checklist_Firma_Empleado_" +
      empleadoEntrega?.nombre +
      "_" +
      moment(new Date()).format("DD_MM_YYYY_HH_mm_ss") +
      "_" +
      ranm;

    let url = await FirebaseStorage.upload(folder + "/" + nombreFirebase, blob);
    return {
      nombreFirebase,
      folder,
      tipo: blob?.type,
      url,
      nombre: nombreFirebase,
    };
  };

  const uploadEvidence = async (fileToUpload) => {
    if (archivo) {
      await FirebaseStorage.delete(folder, archivo?.nombreFirebase);
    }
    const blob = await new Promise((resolve) => {
      fileToUpload.current.toBlob((blob) => resolve(blob));
    });
    const folder = "Archivos";
    const ranm = Math.floor(Math.random() * 1000);
    const nombreFirebase =
      "Checklist_Evidencia_Empleado_" +
      carro?.economico +
      "_" +
      moment(new Date()).format("DD_MM_YYYY_HH_mm_ss") +
      "_" +
      ranm;

    let url = await FirebaseStorage.upload(folder + "/" + nombreFirebase, blob);

    if (!url || url === "error") {
      throw new Error("No se pudo subir la foto. Comprueba que el almacenamiento local esté iniciado y vuelve a intentarlo.");
    }

    // Actualiza el array de fotos subidas
    setUploadedPhotos((prevPhotos) => [...prevPhotos, url]);

    return {
      nombreFirebase,
      folder,
      tipo: blob?.type,
      url,
      nombre: nombreFirebase,
    };
  };

  const [loadingButton, setLoadingButton] = useState(false);

  const [formDetails, setformDetails] = useState({ ...formDefault });
  const [carro, setCarro] = useState(null);
  const [area, setArea] = useState(null);
  const [archivo, setArchivo] = useState(null);
  const [empresa, setEmpresa] = useState(null);
  const [points, setPoints] = useState([]);
  const [ubicacion, setUbicacion] = useState("");
  const [tipoCheklist, setTipoCheklist] = useState("");

  const canvasFirma = useRef(null);
  const [firma, setFirma] = useState(null);
  const [empleadoEntrega, setEmpleadoEntrega] = useState(null);
  const [empleadoRecibe, setEmpleadoRecibe] = useState(null);
  const [rentaPrestamo, setRentaPrestamo] = useState(null);
  const [personaExterna, setPersonaExterna] = useState(null);

  const [lucesDelanteras, setLucesDelanteras] = useState({
    principalDerecha: false,
    principalIzquierda: false,
    direccionalDerecha: false,
    direccionalIzquierda: false,
    intermitenteDerecha: false,
    intermitenteIzquierda: false,
  });
  const [liquidoVehiculo, setLiquidoVehiculo] = useState({
    aceiteMotor: false,
    aceiteTransmision: false,
    liquidoFrenos: false,
    refrigerante: false,
    limpiaParabrisas: false,
    direccionHidraulica: false,
  });
  const [lucesTraseras, setLucesTraseras] = useState({
    direccionalDerecha: false,
    direccionalIzquierda: false,
    intermitenteDerecha: false,
    intermitenteIzquierda: false,
    frenoDerecho: false,
    frenoIzquierdo: false,
    reversaDerecha: false,
    reversaIzquierda: false,
    ledDerecho: false,
    ledIzquierdo: false,
  });
  const [carroceria, setCarroceria] = useState({
    portaCalza: false,
    porteExterior: false,
    parabrisasDelantero: false,
    medallonTrasero: false,
    ventanas: false,
    espejosRetrovisores: false,
    llantas: false,
    aireAcondicionado: false,
    interiores: false,
    asientos: false,
  });
  const [equipoSeguridad, setEquipoSeguridad] = useState({
    cruceta: false,
    gato: false,
    botiquin: false,
    trianguloSeguridad: false,
    alarmaReversa: false,
    extintor: false,
    calzaEstacionamiento: false,
    limpiaparabrisas: false,
    cinturones: false,
    claxon: false,
    cablesCorriente: false,
    llantaExtra: false,
    frenoDeMano: false,
    frenosBalatas: false,
    banderola: false,
    torreta: false,
    ledsLaterales: false,
    conos: false,
  });
  const [bateria, setBateria] = useState({
    terminales: false,
    base: false,
  });
  const [frenos, setFrenos] = useState({
    frontalIzquierda: "minimo",
    frontalDerecha: "minimo",
    traseraIzquierda: "minimo",
    traseraDerecha: "minimo",
    zapataTrasera: "minimo",
  });
  const [llantas, setLlantas] = useState({
    frontalIzquierda: "minimo",
    frontalDerecha: "minimo",
    traseraIzquierda: "minimo",
    traseraDerecha: "minimo",
    extra: "minimo",
  });
  const [gasolinaInfo, setGasolinaInfo] = useState({
    kilometraje: "",
    gasolina: "",
    observaciones: "",
    tipo: "",
    notas: [],
  });
  const [checklistsEmpleadoArchivos, setChecklistsEmpleadoArchivos] = useState([]);
  const [dataGas, setDataGas] = useState(0);
  const [selected, setSelected] = useState();
  const [image, setImage] = useState("default");
  const imageChange = (screen) => {
    setSelected(screen);
    screen == "pickup"
      ? setImage(pickupPlanos)
      : screen === "sedan"
        ? setImage(sedanPlanos)
        : screen === "grua"
          ? setImage(gruaPlanos)
          : screen === "tonelada"
            ? setImage(toneladaPlanos)
            : setImage("default");
  };

  const guardar = async () => {
    let archivo = null;
    if (firma) {
      archivo = await uploadFile(firma);
    }
    setLoadingButton(true);
    let body = {
      datosChecklistsEmpleados: {
        idCarro: carro?.idCarro,
        idArea: area?.idArea,
        idEmpresa: empresa?.idEmpresa,
        seguro: formDetails?.seguro,
        tarjetaCirculacion: formDetails?.tarjetaCirculacion,
        licencia: formDetails?.licencia,
        ubicacion: ubicacion,
        tipoChecklist: tipoCheklist,
      },
      DetallesChecklistsEmpleados: {
        lucesDelanteras: JSON.stringify(lucesDelanteras),
        lucesTraseras: JSON.stringify(lucesTraseras),
        liquidoVehiculo: JSON.stringify(liquidoVehiculo),
        carroceria: JSON.stringify(carroceria),
        equipoSeguridad: JSON.stringify(equipoSeguridad),
        frenos: JSON.stringify(frenos),
        llantas: JSON.stringify(llantas),
        baterias: JSON.stringify(bateria),
      },
      GasolinaChecklistsEmpleados: {
        ...gasolinaInfo,
        notas: points,
      },
      ChecklistsEmpleadoArchivo: {
        ...checklistsEmpleadoArchivos,
      },
      FirmaChecklistsEmpleados: {
        archivo,
        empleadoEntrega: empleadoEntrega?.nombre,
        empleadoRecibe: empleadoRecibe?.nombre,
        rentaPrestamo: rentaPrestamo,
        personaExterna: personaExterna,
      },
    };

    if (editado) {
      body = { ...body, idChecklistEmpleado: id };
    }

    let res = await Servo.post(
      "checklists-empleados/guardar",
      body,
      "checklistsEmpleados",
      true,
      history,
      true
    );
    if (res?.cuerpo) {
      setMessages(res?.cuerpo);
    } else {
      console.error("Error al llamar el endpoint:", res);
    }
    setLoadingButton(false);
  };

  let ChecklistStyles = vs();
  return (
    <Vista style={{ display: "block", backgroundColor: "#FFFFFF" }}>
      {!loading ? (
        <>
          <div className={ChecklistStyles.optionsContainer}>
            <Selector
              toChange={validacionesToChange}
              setScreen={setScreen}
              screen={screen}
            />
          </div>
          <div className={ChecklistStyles.volverCheckListEmpleado}>
          {(permiso[permisoCheck] & 1) === 1 ? (
            <NavLink exact to={"/" + permisoCheck}>
              « Volver
            </NavLink>
          ) : (
            <p>« Volver</p>
          )}
        </div>
          {screen === "DatosGenerales" ? (
            <DatosGenerales
              formDetails={formDetails}
              setformDetails={setformDetails}
              carro={carro}
              setCarro={setCarro}
              empresa={empresa}
              setEmpresa={setEmpresa}
              area={area}
              setArea={setArea}
              ubicacion={ubicacion}
              setUbicacion={setUbicacion}
              tipoCheklist={tipoCheklist}
              setTipoCheklist={setTipoCheklist}
            />
          ) : screen === "Checklist" ? (
            <Check
              lucesDelanteras={lucesDelanteras}
              setLucesDelanteras={setLucesDelanteras}
              liquidoVehiculo={liquidoVehiculo}
              setLiquidoVehiculo={setLiquidoVehiculo}
              lucesTraseras={lucesTraseras}
              setLucesTraseras={setLucesTraseras}
              carroceria={carroceria}
              setCarroceria={setCarroceria}
              equipoSeguridad={equipoSeguridad}
              setEquipoSeguridad={setEquipoSeguridad}
              frenos={frenos}
              setFrenos={setFrenos}
              llantas={llantas}
              setLlantas={setLlantas}
              bateria={bateria}
              setBateria={setBateria}
            />
          ) : screen === "Gasolina" ? (
            <Gasolina
              gasolinaInfo={gasolinaInfo}
              setGasolinaInfo={setGasolinaInfo}
              points={points}
              setPoints={setPoints}
              dataGas={dataGas}
              selected={selected}
              imageChange={imageChange}
              image={image}
              setDataGas={setDataGas}
            />
          ) : screen === "checklistArchivos" ? (
            <ChecklistArchivos
              editado={editado}
              uploadEvidence={uploadEvidence}
              checklistsEmpleadoArchivos={checklistsEmpleadoArchivos}
              setChecklistsEmpleadoArchivos={setChecklistsEmpleadoArchivos}
            />
          ) : screen === "Firma" ? (
            <Firma
              guardar={guardar}
              canvasFirma={canvasFirma}
              empleadoEntrega={empleadoEntrega}
              setEmpleadoEntrega={setEmpleadoEntrega}
              empleadoRecibe={empleadoRecibe}
              setEmpleadoRecibe={setEmpleadoRecibe}
              rentaPrestamo={rentaPrestamo}
              setRentaPrestamo={setRentaPrestamo}
              personaExterna={personaExterna}
              setPersonaExterna={setPersonaExterna}
              permisoCheck={"checklistsEmpleados"}
              firma={firma}
              setFirma={setFirma}
              loadingButton={loadingButton}
            />
          ) : (
            ""
          )}
        </>
      ) : (
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            "@media (min-width: 600px)": {
              margin: "100px",
            },
          }}>
          <CircularProgress />
        </Grid>
      )}
    </Vista>
  );
};
export default Detail;
